import {inArray} from "../../helpers/arrays";


const showPreContactCities = [
    {id: 259, fa_name: 'تهران', en_name: 'tehran'},
    {id: 207, fa_name: 'مشهد', en_name: 'mashhad'},
    {id: 262, fa_name: 'گلبهار', en_name: 'golbahar'},
    {id: 3165, fa_name: 'پردیس', en_name: 'pardis'},
    {id: 1186, fa_name: 'کرج', en_name: 'karaj'},
    {id: 3614, fa_name: 'چمستان', en_name: 'chamestan'},
    {id: 1367, fa_name: 'نور', en_name: 'noor'},
    {id: 1368, fa_name: 'نوشهر', en_name: 'noshahr'},
    {id: 3159, fa_name: 'رویان', en_name: 'royan'},
    {id: 1364, fa_name: 'محمودآباد', en_name: 'mahmodabad'},
    {id: 1358, fa_name: 'سلمانشهر ( متل قو )', en_name: 'salmanshahr'},
    {id: 1353, fa_name: 'تنکابن ( شهسوار )', en_name: 'tonekabon'},
    {id: 308, fa_name: 'رشت', en_name: 'rasht'},
    {id: 1355, fa_name: 'چالوس', en_name: 'chalus'},
    {id: 1634, fa_name: 'آمل', en_name: 'amol'},
    {id: 1351, fa_name: 'بابلسر', en_name: 'babolsar'},
    {id: 6377, fa_name: 'زیباکنار', en_name: 'zibakenar'},
    {id: 1617, fa_name: 'بندرانزلی', en_name: 'anzali'},
    {id: 1356, fa_name: 'رامسر', en_name: 'ramsar'},
    {id: 3429, fa_name: 'کلارآباد', en_name: 'kelarabad'},
    {id: 10384, fa_name: 'ایزدشهر', en_name: 'izadshahr'},
    {id: 3661, fa_name: 'سرخ رود', en_name: 'sorkh_roud'},
    {id: 1357, fa_name: 'ساری', en_name: 'sari'},
];


/**
 * @param city_id {Number}
 *
 * @return Boolean
 * */
export function checkShowPreContactRequestByCity(city_id) {
    const cities = [];

    for (let city of showPreContactCities) {
        cities.push(city.id)
    }

    return inArray(city_id, cities);
}